import { Component, Input } from '@angular/core';

import { trackByValue } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { RtTooltip, IconComponent } from '@core/user-interface-legacy';

import type { MissingFeature } from '../product-order-downgrade.types';

@Component({
  selector: 'rt-multilink-downgrade-item',
  templateUrl: './multilink-downgrade-item.component.html',
  styleUrls: ['./multilink-downgrade-item.component.less'],
  imports: [IconComponent, RtTooltip, TranslatePipe],
})
export class MultilinkDowngradeItemComponent {
  @Input() public missingFeature: MissingFeature;
  @Input() public trial: boolean;

  public trackByValue = trackByValue;
}
